module.exports = __webpack_public_path__ + "img/area_dg.70e7acbc.png";